export const LANGTYPE_MAPPING = {
  en: 'english',
};

export const APP_LINK = {
  appStore: 'https://apps.apple.com/in/app/toofun/id6504480956',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.iyinguo.trchat',
  // androidAPK: 'https://www.toofun.live/apk/TooFun-Google.apk',
};
